import { formatInTimeZone } from './dateFns.helper';

interface FormatDateTimeConfig {
    date: number | string;
    timeZoneId?: string;
    format?: string;
}

// Default matches the old Moment `lll` output, for example: Sep 4, 1986 8:30 PM.
export const formatDateTime = ({ date, timeZoneId, format = 'PP p' }: FormatDateTimeConfig) => {
    return formatInTimeZone(date, timeZoneId, format);
};
